import { render, staticRenderFns } from "./FooterMenu.vue?vue&type=template&id=2cc67962&scoped=true&"
import script from "./FooterMenu.vue?vue&type=script&lang=js&"
export * from "./FooterMenu.vue?vue&type=script&lang=js&"
import style0 from "./FooterMenu.vue?vue&type=style&index=0&lang=css&"
import style1 from "./FooterMenu.vue?vue&type=style&index=1&id=2cc67962&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc67962",
  null
  
)

export default component.exports